export default __webpack_public_path__ + "static/media/battery-power-danger.856662f4.svg";